//中医体质辨识
const MedicineChinese = r => require.ensure([],() =>r(require('@/views/medicineChinese')), 'medicineChinese')
//中医体质档案
const CorporeityRecord = r => require.ensure([],() =>r(require('@/views/medicineChinese/corporeityRecord')), 'corporeityRecord')
//中医体质档案列表
const RecordList = r => require.ensure([],() =>r(require('@/views/medicineChinese/recordList')), 'recordList')
//中医体质辨识问卷首页
const QuestionHome = r => require.ensure([],() =>r(require('@/views/medicineChinese/questionHome')), 'questionHome')
//中医体质辨识结果页
const HabitusResult = r => require.ensure([],() =>r(require('@/views/medicineChinese/habitusResult')), 'habitusResult')
//中医体质辨识题目选择页
const SubjectSelected = r => require.ensure([],() =>r(require('@/views/medicineChinese/subjectSelected')), 'subjectSelected')
//中医体质辨识性别选择页
const SexSelection = r => require.ensure([],() =>r(require('@/views/medicineChinese/sexSelection')), 'sexSelection')

export default {
  path:'/medicine-Chinese',
  name:'medicineChinese',
  redirect:'/medicine-Chinese/corporeity-record',
  component:MedicineChinese,
  children:[{
    path:'corporeity-record',
    name:'corporeityRecord',
    meta:{title:'中医体质档案'},
    component:CorporeityRecord
  },{
    path:'record-list',
    name:'recordList',
    meta: { title:'中医体质档案' },
    component:RecordList
  },{
    path:'home',
    name:'questionHome',
    meta:{title:'体质辨识测试题'},
    component:QuestionHome
  },{
    path:'sex-selection',
    name:'sexSelection',
    meta:{title:'体质辨识测试题'},
    component:SexSelection
  },{
    path:'subject-selected',
    name:'subjectSelected',
    meta:{title:'中医体质辨识测试题'},
    component:SubjectSelected
  },{
    path:'habitus-result',
    name:'habitusResult',
    meta:{title:'体质辨识测试题'},
    component:HabitusResult
  }]
}



// WEBPACK FOOTER //
// ./src/views/medicineChinese/router.js